/*
 * Copyright (c) 2022-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export class AppInfoService {

    private appInfoUrl: string;

    constructor(private http: HttpClient) {
        this.appInfoUrl = environment.apiUrl + '/esciUI/version';
    }

    public getApiVersion(): Observable<any> {
        return this.http.get<string[]>(this.appInfoUrl);
    }
}
